import React from 'react';
import { type IHostProps } from '@wix/yoshi-flow-editor';
import { connect } from '../../../common/components/runtime-context';
import { getLayoutPostSize } from '../../../common/selectors/app-settings-selectors';
import { type Actions, type AppState } from '../../../common/types';
import PageTabs, { ALIGNMENT } from './page-tabs';
import styles from './my-posts-frame-mobile.scss';

type Props = {
  children?: React.ReactNode;
} & ReturnType<typeof mapRuntimeToProps>;

const MyPostsFrameMobile = ({ children, layoutPostSize }: Props) => (
  <section
    className={styles.root}
    style={{ '--width': layoutPostSize ? `${layoutPostSize}px` : undefined }}
  >
    <PageTabs alignment={ALIGNMENT.center} />
    <section className={styles.main}>{children}</section>
  </section>
);

const mapRuntimeToProps = (
  state: AppState,
  _ownProps: {},
  _actions: Actions,
  host: IHostProps,
) => ({
  layoutPostSize: getLayoutPostSize({
    state,
    hostWidth: host.dimensions.width || undefined,
  }),
});

export default connect(mapRuntimeToProps)(MyPostsFrameMobile);
